import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { UtimacoCircuitSwitch } from 'data/utimacoCircuitSwitch/utimacoCircuitSwitch.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import ActionMenus from 'components/ActionMenus';
import UtimacoCircuitSwitchListGridActionMenu from '../UtimacoCircuitSwitchListGridActionMenu';

interface Props {
  data: UtimacoCircuitSwitch[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedUtimacoCircuitSwitch: UtimacoCircuitSwitch
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onShowActionMenuItem: (menuId: string, data: UtimacoCircuitSwitch[]) => void
  onDeleteRow: () => void
  onEdit: () => void
}

const UtimacoCircuitSwitchListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedUtimacoCircuitSwitch,
  onDeleteRow,
  onEdit,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onShowActionMenuItem,
  onSelectItemMenuAction,
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer,
  };
  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }} data-testid="UtimacoCircuitSwitchList">
      <CommonGrid
        createNewText={t('utimacoCircuitSwitch.grid.newUtimacoCircuitSwitch')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        components={components}
        actionMenuClass={UtimacoCircuitSwitchListGridActionMenu}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        showActionMenuItem={onShowActionMenuItem}
        onActionMenuItemClick={onSelectItemMenuAction}
        lastUpdatedAt={lastUpdatedAt}
      >
        <ActionMenus
          name={selectedUtimacoCircuitSwitch?.AFID}
          deleteTitle={t('utimacoCircuitSwitch.deletePopup.title')}
          deleteMessage={t('utimacoCircuitSwitch.deletePopup.message')}
          hasPrivilegesToCreate={false}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default UtimacoCircuitSwitchListGrid;
